/**
 * What a refused refresh means.
 *
 * <p>Rotation revokes the token it was given, so the same stored token can only be
 * spent once. One tab is careful about that — concurrent callers await a single
 * rotation — but localStorage is shared by every tab of the app, and the guard is not.
 * Two tabs whose access tokens expire within the same round trip both present the same
 * stored token: one rotates it, the other is refused.
 *
 * <p>The refusal used to be read as the end of the session, which cleared localStorage
 * — and the token it threw away was the *new* one the winning tab had just stored. Both
 * tabs were then signed out, and the next thing either of them did answered 401 with
 * nothing to show for it. A screen that polls, like the Vimeo migration list, is where
 * this surfaces, because it is the one guaranteed to be asking at the minute the
 * access token expires.
 *
 * <p>So a refusal is only the end of the session when the token we were refused with is
 * still the one in storage. If it has changed underneath us, somebody else rotated it
 * and there is a live session to carry on with.
 *
 * @param presented the refresh token this rotation attempt sent
 * @param stored    what is in storage now, re-read after the refusal
 */
export function afterFailedRefresh(presented, stored) {
  if (stored && presented && stored !== presented) {
    return 'retry';
  }
  return 'sign-out';
}
